<template>
    <div
        class="fixed inset-x-0 bottom-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
        v-show="open"
    >
        <div class="fixed inset-0 transition-opacity">
            <div
                @click="nextSteps"
                class="absolute inset-0 bg-gray-500 opacity-75"
            ></div>
        </div>

        <div
            class="px-4 pt-5 pb-4 overflow-hidden transition-all transform bg-white rounded-lg shadow-xl sm:max-w-lg sm:w-full sm:p-6"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
        >
            <div>
                <div
                    class="flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full"
                >
                    <svg
                        class="w-6 h-6 text-green-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 13l4 4L19 7"
                        />
                    </svg>
                </div>
                <div class="mt-3 text-center sm:mt-5">
                    <h3
                        class="text-lg font-medium leading-6 text-gray-900"
                        id="modal-headline"
                    ></h3>
                    <div class="mt-2">
                        <p class="text-sm leading-5 text-gray-500">
                            Votre business plan est en cours de génération par
                            le système. Un conseiller prendra contact avec vous
                            dans les plus brefs délais après examen de votre
                            dossier.
                        </p>
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-center mt-5">
                <span class="flex w-1/2 rounded-md shadow-sm sm:col-start-2">
                    <button
                        type="button"
                        @click="nextSteps"
                        class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                    >
                        Fermer
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        open: {
            type: Boolean,
            required: true
        }
    },
    created() {
        const escapeHandler = e => {
            if (e.key === "Escape" && this.open) this.close();
        };
        document.addEventListener("keydown", escapeHandler);
        this.$once("hook:destroyed", () => {
            document.removeEventListener("keydown", escapeHandler);
        });
    },
    methods: {
        nextSteps() {
            this.$emit("modal-close");
            this.$router.push({
                name: "Home",
                params: { uid: `${this.$store.state.user.bpiId}` }
            });
        }
    }
};
</script>

<style></style>
